export default function PHP_set_local_infile_handler() {
  return (
    <div>
      <h1>PHP_set_local_infile_handler</h1>
    </div>
  );
}
